import { render, staticRenderFns } from "./RepositoryBranchSelector.vue?vue&type=template&id=11d85fba&scoped=true&"
import script from "./RepositoryBranchSelector.vue?vue&type=script&lang=js&"
export * from "./RepositoryBranchSelector.vue?vue&type=script&lang=js&"
import style0 from "./RepositoryBranchSelector.vue?vue&type=style&index=0&id=11d85fba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d85fba",
  null
  
)

export default component.exports